export class UploadsConfigModel {
    public id: any;
    public templateid: number;
    public uploadtemplatename: string;
    public recordtemplate: string;
    public actiontype: string;
    public transformationroutine: string;
    public uploadtemplatedesc: string;
    public columnname: string;
    public columntype: string;
    public status: string;
    public created_dt: Date;
    public created_by: string;
    public updated_by: string;
    public updated_dt: Date;
    public sqlquery: string;
    public columnorder: number;

    constructor() {
        this.templateid = null;
        this.uploadtemplatename = null;
        this.recordtemplate = null;
        this.actiontype = null;
        this.transformationroutine = null;
        this.uploadtemplatedesc = null;
        this.columnname = null;
        this.columntype = null;
        this.status = null;
        this.created_dt = null;
        this.created_by = null;
        this.updated_by = null;
        this.updated_dt = null;
        this.sqlquery = null;
        this.columnorder = null;
    }
}
